import {
    FruitfulAccountIcon,
    type IconType,
    MoneyMapIcon,
    SplitIcon,
    TargetIcon,
} from 'smoothie';

export enum PreviewSection {
    MONEY_MAP = 'Money map',
    GOALS = 'Goals',
    ACCOUNTS = 'Accounts',
    INCOME_SPLIT = 'Income Split',
}

export const PreviewSectionIconMap: Record<PreviewSection, IconType> = {
    [PreviewSection.MONEY_MAP]: MoneyMapIcon,
    [PreviewSection.GOALS]: TargetIcon,
    [PreviewSection.ACCOUNTS]: FruitfulAccountIcon,
    [PreviewSection.INCOME_SPLIT]: SplitIcon,
};
